import React, { useEffect } from 'react';
import data from '../data';

function Contact() {
  useEffect(() => {
    document.body.classList.add('contact-page');
    return () => {
      document.body.classList.remove('contact-page');
    };
  }, []);

  return (
    <div className="contact">
      <div dangerouslySetInnerHTML={{ __html: data.contact }} />
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <img src="/image/scaled/MdM_workingatBM.jpg" alt="Working at the British Museum" style={{ maxWidth: '35%', height: 'auto' }} />
      </div>
    </div>
  );
}

export default Contact;